import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import deleteBoard from '../../rest/delete-board/index.tsx';
import {
	type Action,
	DELETE_BOARD,
	deleteBoardFailed,
	boardDeleted,
} from '../../state/actions.tsx';
import { getBoard, getOnBoardDeleted, getOnBoardDeleteFailed } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const deleteBoardEpic = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(DELETE_BOARD).mergeMap(() => {
		const state = store.getState();
		const board = getBoard(state);

		return deleteBoard(board.id)
			.mergeMap(() => {
				getOnBoardDeleted(state)(board);
				return Observable.of(boardDeleted());
			})
			.catch((error: FetchError) => {
				log.safeErrorWithoutCustomerData(
					'directories.boards-v2.delete-modal.ops.delete-board',
					error.message,
					error,
				);
				const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
				getOnBoardDeleteFailed(state)(board, reason);
				return Observable.of(deleteBoardFailed({ reason }));
			});
	});

export default deleteBoardEpic;
